
export default {
  computed: {
    hasTitle() {

      if (!this.value)
        return false;

      return !!this.$u.htmlHasContent(
        this.$u.localize(
          this.value.title,
        ),
      );
    },
    hasBody() {

      if (!this.value)
        return false;

      return !!this.$u.htmlHasContent(
        this.$u.localize(
          this.value.body,
        ),
      );
    },
    hasFile() {

      if (!this.value)
        return false;

      return !!this.value.file;
    },
    hasButtons() {

      if (!this.value)
        return false;

      return !!(
        this.value.buttons &&
        this.value.buttons.length
      );
    },
    hasContent() {

      if (!this.value)
        return false;

      return !!(
        this.hasTitle ||
        this.hasBody ||
        (!this.noFile && this.hasFile) ||
        this.hasButtons
      );
    },
  },
};
